import { EmbedContextIdProvider} from './embed_context_id_provider';
import { NonPersistentDistinctIdProvider } from './non_persistent_distinct_id_provider';
import { CrossDomainCookieDistinctIdProvider } from './cross_domain_cookie_distinct_id_provider';

export const availableProviders = {
    EmbedContextIdProvider,
    NonPersistentDistinctIdProvider,
    CrossDomainCookieDistinctIdProvider
};

export const getContextProvider = (environment, config = {}) => {
    let Provider;

    if (config.provider?.name && availableProviders[config.provider.name]) {
        Provider = availableProviders[config.provider.name]
    } else {
        Provider = CrossDomainCookieDistinctIdProvider;
    }

    return new Provider(environment, config);
};